import React from 'react';
import {
  Box,
  Typography,
  Paper,
  IconButton,
  alpha,
} from '@mui/material';
import { LaptopMac, PhoneIphone, Circle, Cancel } from '@mui/icons-material';

interface DevicesTabProps {
  colors: any;
  glassStyle: any;
}

const DevicesTab: React.FC<DevicesTabProps> = ({ colors, glassStyle }) => {
  const activeSessions = [
    { id: 1, device: 'Windows PC', browser: 'Chrome', location: 'Mumbai, India', current: true, icon: <LaptopMac sx={{ fontSize: 30 }} /> },
    { id: 2, device: 'iPhone 13 Pro', browser: 'Discord iOS', location: 'Bangalore, India', current: false, lastActive: '2 days ago', icon: <PhoneIphone sx={{ fontSize: 30 }} /> }
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Devices
      </Typography>
      <Typography color={colors.textSecondary} sx={{ mb: 4 }}>
        Devices currently logged into your account.
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 4, ...glassStyle }}>
        <Typography variant="subtitle2" color={colors.textSecondary} sx={{ mb: 3, textTransform: 'uppercase', fontWeight: 700, fontSize: '0.75rem' }}>
          Current Device
        </Typography>
        {activeSessions.filter(s => s.current).map(session => (
          <Box key={session.id} sx={{ display: 'flex', alignItems: 'center', gap: 3, p: 3, bgcolor: alpha(colors.success, 0.1), borderRadius: '16px', mb: 5 }}>
            <Box sx={{ color: colors.success }}>{session.icon}</Box>
            <Box>
              <Typography fontWeight={700} color={colors.textPrimary} variant="h6">{session.device}</Typography>
              <Typography variant="body2" color={colors.textPrimary}>{session.browser} • {session.location}</Typography>
              <Typography variant="caption" color={colors.success} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontWeight: 700, mt: 0.5 }}>
                <Circle sx={{ fontSize: 10 }} /> Online now
              </Typography>
            </Box>
          </Box>
        ))}
        
        <Typography variant="subtitle2" color={colors.textSecondary} sx={{ mb: 3, textTransform: 'uppercase', fontWeight: 700, fontSize: '0.75rem' }}>
          Other Devices
        </Typography>
        {activeSessions.filter(s => !s.current).map(session => (
          <Box key={session.id} sx={{ display: 'flex', alignItems: 'center', gap: 3, p: 3, border: `1px solid ${alpha(colors.textSecondary, 0.2)}`, borderRadius: '16px' }}>
            <Box sx={{ color: colors.textSecondary }}>{session.icon}</Box>
            <Box>
              <Typography fontWeight={700} color={colors.textPrimary} variant="h6">{session.device}</Typography>
              <Typography variant="body2" color={colors.textSecondary}>{session.browser} • {session.location}</Typography>
              <Typography variant="caption" color={colors.textSecondary}>{session.lastActive}</Typography>
            </Box>
            <IconButton size="small" sx={{ ml: 'auto' }}>
              <Cancel fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default DevicesTab;